import { NgModule } from '@angular/core'
import { CustomOrderHistoryComponent } from './custom-order-history.component'
import { CommonModule } from '@angular/common'
import { CustomCartSharedModule } from '../../cart/cart-shared/custom-cart-shared.module'
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { SharedModule } from '../../shared/shared.module'
import { FormsModule } from '@angular/forms'
import { ListNavigationModule, SpinnerModule } from '@spartacus/storefront'
import { RouterModule } from '@angular/router'
import { MaterialModule } from '../../shared/material.module'
import { OrderStatusModule } from '../order-status/order-status.module'

@NgModule({
  declarations: [CustomOrderHistoryComponent],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    RouterModule,
    UrlModule,
    SpinnerModule,
    MaterialModule,
    ListNavigationModule,
    CustomCartSharedModule,
    SharedModule,
    OrderStatusModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        AccountOrderHistoryComponent: {
          component: CustomOrderHistoryComponent
        }
      }
    })
    // provideConfig(<I18nConfig>{
    //     i18n: {
    //         resources: translationOverwrites,
    //     },
    // })
  ],
  exports: [CustomOrderHistoryComponent]
})
export class CustomOrderHistoryModule {}
